<template>
  <div class="content-container">
    <!-- Search Component -->
    <search-comp @onSearch="onSearch" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col w-25">
              <div class="das-form-input">
                <div class="label">{{ $t('field.fromDate') }}</div>
                <div class="child-w-80">
                  <SingleCalendar
                    v-model="searchParams.startDate"
                    class="use-icon"
                    :date-data="searchParams.startDate"
                    @input="onChangeStartDate($event)"
                  />
                </div>
              </div>
            </div>
            <div class="das-form-col w-25">
              <div class="das-form-input">
                <div class="label">{{ $t('field.toDate') }}</div>
                <div class="child-w-80">
                  <SingleCalendar
                    v-model="searchParams.endDate"
                    class="use-icon"
                    :date-data="searchParams.endDate"
                    @input="onChangeEndDate($event)"
                  />
                </div>
              </div>
            </div>
            <div class="das-form-col w-25">
              <div class="das-form-input">
                <div class="label">{{ $t('field.object') }}</div>
                <div class="child-w-80">
                  <!-- <select v-model="searchParams.objectType">
                    <option
                      v-for="item in objectTypeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </select> -->
                  <el-select v-model="searchParams.objectType" placeholder="">
                    <el-option
                      v-for="item in objectTypeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </div>
              </div>
            </div>
            <div class="das-form-col w-25">
              <div class="das-form-input">
                <div class="label">
                  {{ $t('field.packagePackageGroupCode') }}
                </div>
                <div class="child-w-80">
                  <input v-model="searchParams.keyword" type="text" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <!-- <PackageDiarySearch @onSearch="fnSearch" /> -->
    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :rows="rows"
        :default-col-def="colDef"
        :suppress-row-click-selection="true"
        :auto-select-first-row="false"
        dom-layout="scroll"
        class="agGrid"
        @refresh="onRefresh"
      />
    </div>
    <div class="grid-bottom">
      <GridPaging
        target="agGrid"
        :total-size="totalPage"
        :page-num="currentPage"
        @pageChanged="onPageChanged"
        @onPageSizeChange="onPageSizeChange"
      />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// import bus from '@/utils/bus'
import SingleCalendar from '@/components/ui/SingleCalendar.vue'
import {
  getListBuildingApi,
  addBuildingApi,
  updateBuildingApi,
  deleteBuildingApi
} from '@/api/Room/building.js'
import { getPackageLogListApi } from '@/api/Service_Policy/packageLog'
import { Message } from 'element-ui'
import PackageDiarySearch from './components/PackageDiarySearch.vue'
import { CellDescription } from './components/PackageDiaryCellRenders'
export default {
  components: {
    PackageDiarySearch,
    SingleCalendar,
    CellDescription
  },
  data() {
    return {
      loading: false,
      totalPage: 0,
      currentPage: 0,
      searchParams: {
        pageSize: 10,
        pageNum: 1,
        orderTp: 'DESC',
        keyword: '',
        startDate: null,
        endDate: null,
        objectType: null,
        orderBy: null
      },

      // SELECT OPTIONS
      objectTypeOptions: [
        {
          value: null,
          label: this.$t('variables.all')
        },
        {
          value: 1,
          label: this.$t('variables.packageCategory')
        },
        {
          value: 2,
          label: this.$t('variables.packageGroup')
        },
        {
          value: 3,
          label: this.$t('variables.package')
        },
        {
          value: 4,
          label: this.$t('variables.packageDetail')
        }
      ],

      buildingItem: {
        building_no: '',
        name: '',
        id: null
      },
      colDef: {
        suppressMovable: true,
        resizable: false,
        sortable: true
      },
      columns: [
        {
          headerName: this.$t('grid.column.packagePackageGroupCode'),
          field: 'object_code',
          // cellClass: "grid-cell-centered",
          minWidth: 300
        },
        {
          headerName: this.$t('grid.column.staff'),
          field: 'staff_name',
          // cellClass: "grid-cell-centered",
          minWidth: 100
        },
        {
          headerName: this.$t('grid.column.object'),
          field: 'object_type',
          cellRenderer: params => {
            let tmp = ''
            switch (params.value) {
              case 1:
                tmp = this.$t('variables.packageCategory')
                break
              case 2:
                tmp = this.$t('variables.packageGroup')
                break
              case 3:
                tmp = this.$t('variables.package')
                break
              case 4:
                tmp = this.$t('variables.packageDetail')
                break
              default:
                break
            }
            return tmp
          },
          // cellClass: "grid-cell-centered",
          minWidth: 100
        },
        {
          headerName: this.$t('grid.column.task'),
          field: 'type_id',
          // cellClass: "grid-cell-centered",
          minWidth: 100,
          cellRenderer: params => {
            let tmp = ''
            switch (params.value) {
              case 1:
                tmp = this.$t('variables.add')
                break
              case 2:
                tmp = this.$t('variables.edit')
                break
              case 3:
                tmp = this.$t('variables.delete')
                break
              case 4:
                tmp = this.$t('variables.stopSelling')
                break
              default:
                break
            }
            return tmp
          }
        },
        {
          headerName: this.$t('grid.column.timeOperation'),
          field: 'time',
          valueFormatter: params =>
            this.$moment(params.value).format('DD/MM/YYYY hh:mm:ss'),
          // cellClass: "grid-cell-centered",
          minWidth: 200
        },
        {
          headerName: this.$t('grid.column.explanation'),
          field: 'description',
          cellRenderer: 'CellDescription',
          wrapText: true,
          autoHeight: true,
          minWidth: 400
        }
      ],
      rows: []
      // Select options
    }
  },

  mounted() {
    this.attachData()
  },
  methods: {
    fnSearch(searchInputs) {
      this.searchParams = { ...this.searchParams, ...searchInputs }
      this.searchParams.pageNum = 1
      this.attachData()
    },
    onSearch() {
      this.searchParams.pageNum = 1
      this.attachData()
    },
    onReset() {
      this.searchParams = {
        ...this.searchParams,
        orderTp: 'DESC',
        keyword: '',
        startDate: null,
        endDate: null,
        objectType: null,
        orderBy: null,
        pageNum: 1
      }
      this.attachData()
    },
    onRefresh(data) {
      let params = {
        orderBy: data.orderBy,
        orderTp: data.sort
      }
      this.searchParams = { ...this.searchParams, ...params }
      this.attachData()
    },
    onChangeDate(date, field) {
      this.searchParams[field] = this.$moment(date).format('YYYY-MM-DD')
      // this.searchParams[field] = date
    },
    onChangeStartDate(date) {
      this.searchParams.startDate = this.$moment(date).format('YYYY-MM-DD')
      if (
        this.searchParams.endDate &&
        this.searchParams.startDate > this.searchParams.endDate
      ) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.fromDateMustEarlierThanToDate')
        })
        this.searchParams.endDate = this.$moment(this.searchParams.startDate)
          .add(1, 'd')
          .toDate()
      }
    },
    onChangeEndDate(date) {
      this.searchParams.endDate = this.$moment(date).format('YYYY-MM-DD')
      if (
        this.searchParams.startDate &&
        this.searchParams.startDate > this.searchParams.endDate
      ) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.fromDateMustEarlierThanToDate')
        })
        this.searchParams.endDate = this.$moment(this.searchParams.startDate)
          .add(1, 'd')
          .toDate()
      }
    },
    async onPageChanged(pageNum) {
      this.searchParams.pageNum = pageNum
      await this.attachData()
    },
    async onPageSizeChange(pageSize) {
      this.searchParams.pageSize = pageSize
      this.searchParams.pageNum = 1
      await this.attachData()
    },
    async attachData() {
      this.loading = true

      try {
        let data = await getPackageLogListApi(this.searchParams)
        this.rows = data.data
        this.totalPage = Math.ceil(data.total / this.searchParams.pageSize)
        this.currentPage = data.data.length == 0 ? 0 : data.page_num
      } catch (err) {
        console.log(err)
      }

      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
